import { useCallback, useEffect, useRef, useState } from "react";

import { PublicGetRequest } from "utils/ApiRequest";
import { normalizeSponsors } from "utils/sponsors";

function useSponsors() {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const requestId = useRef(0);

  const selectYear = useCallback((year) => {
    requestId.current += 1;
    const current = requestId.current;
    setSelectedYear(year);
    setLoading(true);
    setFailed(false);
    PublicGetRequest(
      `/sponsors/${year}`,
      (res) => {
        if (current !== requestId.current) {
          return;
        }
        setData(normalizeSponsors(res.data));
        setLoading(false);
      },
      () => {
        if (current !== requestId.current) {
          return;
        }
        setData(null);
        setFailed(true);
        setLoading(false);
      }
    );
  }, []);

  useEffect(() => {
    requestId.current += 1;
    const current = requestId.current;
    setLoading(true);
    setFailed(false);
    PublicGetRequest(
      "/sponsors/years",
      (res) => {
        if (current !== requestId.current) {
          return;
        }
        const list = Array.isArray(res.data)
          ? res.data.filter((year) => typeof year === "number").sort((a, b) => b - a)
          : [];
        setYears(list);
        if (list.length === 0) {
          setData(null);
          setFailed(true);
          setLoading(false);
          return;
        }
        selectYear(list[0]);
      },
      () => {
        if (current !== requestId.current) {
          return;
        }
        setYears([]);
        setData(null);
        setFailed(true);
        setLoading(false);
      }
    );
  }, [attempt, selectYear]);

  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  return { years, selectedYear, data, loading, failed, selectYear, retry };
}

export default useSponsors;
